import Image from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ImageNodeView } from './ImageNodeView';

export interface ResizableImageOptions {
  inline: boolean;
  allowBase64: boolean;
  HTMLAttributes: Record<string, unknown>;
  /** Called with a user-facing message when an image operation fails. */
  onError?: (message: string) => void;
}

/**
 * ResizableImage — the base TipTap Image node (name stays "image") extended
 * with width + caption attributes and a React NodeView that authed-loads the
 * image, supports resize + crop + alt/caption editing.
 */
export const ResizableImage = Image.extend<ResizableImageOptions>({
  addOptions() {
    return {
      ...this.parent!(),
      onError: undefined,
    };
  },

  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: null,
        parseHTML: (el) => {
          const w = (el as HTMLElement).style.width || el.getAttribute('width');
          const n = w ? parseInt(w, 10) : NaN;
          return Number.isFinite(n) ? n : null;
        },
        renderHTML: (attrs) =>
          attrs.width ? { style: `width: ${attrs.width}px` } : {},
      },
      caption: {
        default: null,
        parseHTML: (el) => (el as HTMLElement).getAttribute('data-caption'),
        renderHTML: (attrs) =>
          attrs.caption ? { 'data-caption': attrs.caption } : {},
      },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageNodeView, { as: 'div' });
  },
});
